import { createElementFromHTML } from './../../js/helper';
import { AjaxLoader } from './../../js/ajax-loader';
import tippy from 'tippy.js';
import { bindTrackingClick } from './../../js/tracking';

class Glossary {
    constructor (element, options) {
        const defaults = {
            initAttr: 'data-glossary',
            contextAttr: 'data-glossary-context',
            loader: null
        };

        this.settings = Object.assign({}, defaults, options);

        this.$glossary = element;

        if (this.settings.loader !== null) {
            this.$loader = createElementFromHTML(this.settings.loader);
        }

        if (this.$glossary.getAttribute(this.settings.initAttr + '-init') === null) {
            this.initialize();
            this.$glossary.setAttribute(this.settings.initAttr + '-init', 'init');
        }
    }

    initialize () {
        this.glossaryPath = this.$glossary.getAttribute(this.settings.initAttr);

        if (this.glossaryPath) {
            this.setEvents();
        }
    }

    setEvents () {
        const glossaryPath = this.glossaryPath;
        const $body = document.querySelector('body');
        const $loader = this.$loader;
        const $glossary = this.$glossary;
        const settings = this.settings;
        let glossaryPlacement = 'right-start';

        if ($glossary.getAttribute('data-glossary-placement')) {
            glossaryPlacement = $glossary.getAttribute('data-glossary-placement');
        }

        tippy(this.$glossary, {
            arrow: false,
            duration: [250, 250],
            offset: [0, 0],
            content: '',
            allowHTML: true,
            placement: glossaryPlacement,
            trigger: 'click',
            interactive: true,
            appendTo: () => document.body,
            maxWidth: 'none',
            onCreate (instance) {
                // Setup our own custom state properties
                instance._isFetching = false;
                instance._error = null;

                instance._closeButton = document.createElement('a');
                instance._closeButton.classList.add('glossary-close');
                instance._closeButton.innerHTML = '<i>x</i>';

                if (typeof $glossary.getAttribute(settings.contextAttr) !== 'undefined') {
                    instance.popper.classList.add($glossary.getAttribute(settings.contextAttr));
                }

                instance._closeButton.addEventListener('click', instance.hide);
            },
            onShow (instance) {
                if ($loader) {
                    $glossary.appendChild($loader);
                }

                if (instance._isFetching || instance._error) {
                    return;
                }

                instance._isFetching = true;

                $body.classList.add('has--tippy');

                this.result = new AjaxLoader(glossaryPath, {
                    onSuccess: (resultText) => {
                        const $result = createElementFromHTML(resultText);
                        const $resultContent = createElementFromHTML($result.innerHTML);
                        $resultContent.appendChild(instance._closeButton);
                        instance.setContent($resultContent);
                        instance._isFetching = false;
                        if ($loader) {
                            $loader.parentNode.removeChild($loader);
                        }
                        bindTrackingClick($resultContent);
                    }
                });
            },
            onHidden (instance) {
                instance.setContent('');
                // Unset these properties so new network requests can be initiated
                instance._error = null;
                // instance._closeButton = null;
                $body.classList.remove('has--tippy');
            }
        });
    }
}

export { Glossary };
